// Mock data for Mt. Olive Missionary Baptist Church

export const churchInfo = {
  name: "Mt. Olive Missionary Baptist Church",
  address: "420 E Jefferson St, Americus, GA 31709",
  phone: "(229) 924-8300",
  email: "questions@mtolivembc.com",
  rating: 4.3,
  type: "Baptist Church",
  locationId: "3QFC+VR Americus, Georgia",
  pastor: {
    name: "Rev. Dr. H.C. Wilson",
    title: "Senior Pastor",
    image: "https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/hfybatgh_Rev.%20and%201st%20Lady%20Wilson.jpg",
    welcomeMessage: "Welcome to Mt. Olive Missionary Baptist Church! We are a faith-filled community dedicated to spreading God's love and serving our neighbors. Whether you're seeking spiritual growth, fellowship, or a place to call home, we invite you to join our church family. May God's blessings be upon you."
  },
  firstLady: {
    name: "Freddie Wilson",
    title: "First Lady",
    image: "https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/w6ujm8dk_Freddie%20Wilson.jpg"
  },
  tagline: "The Church on the Hill where everybody is somebody",
  serviceTimes: [
    {
      day: "Sunday",
      note: "1st, 3rd, and 4th Sundays",
      services: [
        { name: "Sunday School", time: "9:30 AM" },
        { name: "Church Service", time: "10:00 AM" }
      ]
    }
  ],
  socialMedia: {
    facebook: "https://facebook.com/mtoliveamerica",
    youtube: "https://youtube.com/@mtoliveamerica",
    instagram: "https://instagram.com/mtoliveamerica"
  },
  officeHours: [
    { days: "Monday - Friday", hours: "By Appointment Only" },
    { days: "Saturday - Sunday", hours: "Closed" }
  ]
};

export const aboutInfo = {
  history: "Mt. Olive Missionary Baptist Church is an active Baptist congregation in Americus, Georgia, often referred to on our social media as 'The Church on the Hill where everybody is somebody.' Under the pastoral leadership of Rev. Dr. H.C. Wilson, we have been a cornerstone of faith in the Americus community, hosting worship services, special events (like women's day and guest preaching), and community gatherings. Church members who have joined Mt. Olive note Rev. Dr. Wilson as the pastor at the time of their membership, indicating his long-standing role as shepherd of the congregation. Under his leadership, Mt. Olive has been active in local spiritual life through regular worship services, special observances, community outreach and fellowship activities, and serving as a gathering place for area residents' spiritual and social support needs.",
  mission: "To glorify God by making disciples of Jesus Christ through worship, biblical teaching, fellowship, and service to our community and the world.",
  vision: "To be a thriving, multi-generational church where every person experiences God's love, grows in faith, and serves with purpose.",
  coreBeliefs: [
    {
      title: "The Holy Bible",
      description: "We believe the Bible is the inspired, infallible Word of God and our ultimate authority for faith and practice."
    },
    {
      title: "The Trinity",
      description: "We believe in one God eternally existing in three persons: Father, Son, and Holy Spirit."
    },
    {
      title: "Salvation",
      description: "We believe salvation is by grace alone through faith alone in Jesus Christ alone."
    },
    {
      title: "The Church",
      description: "We believe the church is the body of Christ, called to worship, fellowship, discipleship, and service."
    },
    {
      title: "Baptism & Communion",
      description: "We believe in baptism by immersion and regular observance of the Lord's Supper."
    },
    {
      title: "The Great Commission",
      description: "We believe in spreading the Gospel and making disciples of all nations."
    }
  ]
};

export const leadership = [
  {
    name: "Rev. Dr. H.C. Wilson",
    title: "Senior Pastor",
    image: "https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/hfybatgh_Rev.%20and%201st%20Lady%20Wilson.jpg",
    bio: "Rev. Dr. H.C. Wilson has faithfully served as Senior Pastor, leading with wisdom, compassion, and a heart for God's people."
  },
  {
    name: "Freddie Wilson",
    title: "First Lady",
    image: "https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/w6ujm8dk_Freddie%20Wilson.jpg",
    bio: "First Lady Freddie Wilson ministers alongside her husband with grace and dedication to the church family."
  },
  {
    name: "Deacon Board",
    title: "Church Deacons",
    image: "https://customer-assets.emergentagent.com/job_faith-fellowship-ga/artifacts/7sye2odb_praying%20black%20men%20%2834%29.png",
    bio: "Our faithful deacons serve the congregation with dedication and spiritual leadership."
  },
  {
    name: "Ministry Leaders",
    title: "Various Ministries",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=400",
    bio: "Dedicated leaders serving across all church ministries to build up the body of Christ."
  }
];

export const ministries = [
  {
    id: "youth",
    name: "Youth Ministry",
    description: "Empowering young people to grow in faith, build meaningful relationships, and become leaders for Christ in their generation.",
    leader: "Youth Director",
    meetingTime: "Sundays at 6:00 PM",
    image: "https://images.unsplash.com/photo-1717278088457-b145be192237?w=800",
    activities: ["Bible Study", "Youth Services", "Summer Camps", "Community Service"]
  },
  {
    id: "women",
    name: "Women's Ministry",
    description: "A sisterhood of faith where women gather for prayer, Bible study, fellowship, and mutual encouragement in their spiritual journey.",
    leader: "Women's Ministry Leader",
    meetingTime: "2nd Saturday of each month at 10:00 AM",
    image: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=800",
    activities: ["Bible Study", "Prayer Meetings", "Women's Retreats", "Community Outreach"]
  },
  {
    id: "men",
    name: "Men's Ministry",
    description: "Building godly men through fellowship, accountability, and service as we support one another in faith and family leadership.",
    leader: "Men's Ministry Leader",
    meetingTime: "1st Saturday of each month at 8:00 AM",
    image: "https://images.unsplash.com/photo-1565813086292-604790c8a97b?w=800",
    activities: ["Men's Breakfast", "Bible Study", "Service Projects", "Brotherhood Fellowship"]
  },
  {
    id: "music",
    name: "Music Ministry",
    description: "Lifting our voices in praise and worship to glorify God through song, leading the congregation in heartfelt worship.",
    leader: "Minister of Music",
    meetingTime: "Choir Rehearsal: Thursdays at 7:00 PM",
    image: "https://images.unsplash.com/photo-1582880159736-8bb57334d2f5?w=800",
    activities: ["Choir", "Praise Team", "Instrumental Music", "Special Music Events"]
  },
  {
    id: "outreach",
    name: "Outreach Ministry",
    description: "Sharing God's love beyond our walls through community service, missions, and compassionate care for those in need.",
    leader: "Outreach Coordinator",
    meetingTime: "Contact for upcoming events",
    image: "https://images.unsplash.com/photo-1637285051313-5316119f852e?w=800",
    activities: ["Food Pantry", "Community Events", "Mission Trips", "Neighborhood Outreach"]
  },
  {
    id: "audiovisual",
    name: "Audio/Visual Ministry",
    description: "Supporting worship through technical excellence in sound, lighting, and media presentation.",
    leader: "Tech Director",
    meetingTime: "Sundays - Technical Setup",
    image: "https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?w=800",
    activities: ["Sound Engineering", "Video Production", "Livestream Management", "Technical Support"]
  },
  {
    id: "biblestudy",
    name: "Bible Study Groups",
    description: "Growing deeper in God's Word through small group studies, discussion, and practical application of Scripture.",
    leader: "Various Group Leaders",
    meetingTime: "Multiple groups throughout the week",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800",
    activities: ["Weekly Studies", "Book Studies", "Topical Studies", "Small Groups"]
  }
];

export const events = [
  {
    id: 1,
    title: "Sunday Worship Service",
    date: "1st, 3rd, & 4th Sundays",
    time: "10:00 AM",
    location: "Main Sanctuary",
    description: "Join us for inspiring worship, powerful preaching, and heartfelt fellowship.",
    recurring: true
  },
  {
    id: 2,
    title: "Wednesday Bible Study",
    date: "Every Wednesday",
    time: "7:00 PM",
    location: "Via Zoom",
    description: "Dive deeper into God's Word with practical teaching, discussion, and prayer. Join us online from the comfort of your home.",
    recurring: true
  },
  {
    id: 3,
    title: "Youth Night",
    date: "TBD",
    time: "To Be Announced",
    location: "Youth Center",
    description: "We're organizing exciting faith-filled activities for our young people. Details coming soon!",
    recurring: false
  },
  {
    id: 4,
    title: "Women's Fellowship",
    date: "2nd Saturday",
    time: "10:00 AM",
    location: "Fellowship Hall",
    description: "Ladies, join us for encouragement, prayer, and fellowship.",
    recurring: true
  },
  {
    id: 5,
    title: "Men's Breakfast",
    date: "1st Saturday",
    time: "8:00 AM",
    location: "Fellowship Hall",
    description: "Brothers, gather for food, fellowship, and faith.",
    recurring: true
  }
];

export const sermons = [
  {
    id: 1,
    title: "Walking in Faith",
    pastor: "Rev. Dr. H.C. Wilson",
    date: "Recent Sunday",
    scripture: "Hebrews 11:1-6",
    thumbnail: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=400",
    videoUrl: "#",
    audioUrl: "#"
  },
  {
    id: 2,
    title: "The Power of Prayer",
    pastor: "Rev. Dr. H.C. Wilson",
    date: "Recent Sunday",
    scripture: "James 5:16",
    thumbnail: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?w=400",
    videoUrl: "#",
    audioUrl: "#"
  },
  {
    id: 3,
    title: "Love One Another",
    pastor: "Rev. Dr. H.C. Wilson",
    date: "Recent Sunday",
    scripture: "John 13:34-35",
    thumbnail: "https://images.unsplash.com/photo-1507692049790-de58290a4334?w=400",
    videoUrl: "#",
    audioUrl: "#"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1519491050282-cf00c82424b4?w=800",
    caption: "Sunday Worship Service",
    category: "worship"
  },
  {
    id: 2,
    url: "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?w=800",
    caption: "Prayer and Fellowship",
    category: "fellowship"
  },
  {
    id: 3,
    url: "https://images.unsplash.com/photo-1507692049790-de58290a4334?w=800",
    caption: "Community Outreach",
    category: "outreach"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=800",
    caption: "Choir Ministry",
    category: "worship"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800",
    caption: "Church Family",
    category: "fellowship"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?w=800",
    caption: "Bible Study",
    category: "study"
  }
];

export const givingOptions = [
  {
    id: "tithe",
    name: "Tithes & Offerings",
    description: "Regular tithes and offerings to support the ongoing ministry of Mt. Olive.",
    suggested: [10, 25, 50, 100, 250]
  },
  {
    id: "building",
    name: "Building Fund",
    description: "Support our building maintenance and improvement projects.",
    suggested: [25, 50, 100, 500]
  },
  {
    id: "missions",
    name: "Missions & Outreach",
    description: "Support our local and global mission efforts to spread the Gospel.",
    suggested: [20, 50, 100, 200]
  },
  {
    id: "special",
    name: "Special Giving",
    description: "Contribute to special church events, programs, and needs.",
    suggested: [25, 50, 100, 250]
  }
];
